import styled from "styled-components";

export const ContainerToPreview = styled.div`
  width: 310px;
  max-width: 310px;
  min-width: 310px;
  height: 438px;
  max-height: 438px;
  min-height: 438px;
`;

export const Container = styled.div`
  padding: 3rem;
`;
